"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replacerMapToTupleArray = exports.replacerMapToObject = void 0;
const replacerMapToObject = (_, value) => {
    if (value instanceof Map) {
        return Object.fromEntries(value);
    }
    else {
        return value;
    }
};
exports.replacerMapToObject = replacerMapToObject;
const replacerMapToTupleArray = (_, value) => {
    if (value instanceof Map) {
        return Array.from(value);
    }
    else {
        return value;
    }
};
exports.replacerMapToTupleArray = replacerMapToTupleArray;
//# sourceMappingURL=json.js.map